/**
 * Reads and parses the currently active tab from localStorage.
 *
 * @returns {Object|null} The saved tab object, or null if none is saved or parsing fails
 */
export function getActiveTab() {
  const savedTab = localStorage.getItem('activeTab');
  if (!savedTab) {
    return null;
  }

  try {
    const tab = JSON.parse(savedTab);
    // if (tab.path !== window.location.pathname) {
    //   return null;
    // }
    return tab;
  } catch (error) {
    console.error('Failed to parse activeTab from localStorage:', error);
    return null;
  }
}

/**
 * Persists a serializable subset of the given tab (and its route path) to localStorage as the active tab.
 *
 * @param {Object} tab - The tab object, expected to have an `id`, `title`, and optional `collection`
 * @param {Object} route - The current route object, used to record `path`
 * @returns {void}
 */
export function setActiveTab(tab, route) {
  if (tab && typeof tab === 'object' && 'id' in tab) {
    try {
      const serializableTab = {
        id: tab?.id,
        title: tab?.title,
        collection: tab?.collection?.value,
        path: route?.path,
      };
      localStorage.setItem('activeTab', JSON.stringify(serializableTab));
    } catch (error) {
      console.error('Failed to save tab to localStorage:', error);
    }
  } else {
    console.warn('Invalid tab object provided:', tab);
  }
}

/**
 * Resets the active tab and current posts filter in localStorage to their default values,
 * using the current window path as the tab's path.
 *
 * @returns {void}
 */
export function setDefaultTab() {
  try {
    const serializableTab = {
      id: 0,
      title: '',
      collection: '',
      path: window.location.pathname,
    };
    localStorage.setItem('activeTab', JSON.stringify(serializableTab));
    localStorage.setItem('currentPostsFilter', JSON.stringify({ id: 0, label: 'All', activeTab: 0 }));
  } catch (error) {
    console.error('Failed to save tab to localStorage:', error);
  }
}
